import { Injectable, EventEmitter, Inject } from '@angular/core';
import { Http } from '@angular/http';

import { IErrorHandler } from '../dataModels/contracts/IErrorHandler';
import { Configuration } from '../configurations/shared.config';

@Injectable()
export class UserControlServiceService {

    public setGrainEvent: EventEmitter<any> = new EventEmitter<any>();
    private _errorHandler: IErrorHandler;
    public userControl: any = {};

    constructor(private _http: Http, @Inject("IErrorHandler") handler: IErrorHandler) {
        this._errorHandler = handler;
    }

    getAuthorizedModules() {
        return this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.authorizeModules)
            .map(x => x.json());
    }

    getAuthorizedPages() {
        return this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.authorizePages)
            .map(x => x.json());
    }

    async authorizeControls(controlsNames: string[]): Promise<any> {
        return await this.authorizeItems(Configuration.urls.authorizeCntrls, controlsNames);
    }

    async authorizePages(pageNames: string[]): Promise<any> {
        return await this.authorizeItems(Configuration.urls.authorizePages, pageNames);
    }

    async authorizeModules(moduleNames: string[]): Promise<any> {
        return await this.authorizeItems(Configuration.urls.authorizeModules, moduleNames);
    }

    private async authorizeItems(url: string, itemNames: string[]): Promise<any> {
        const response = await this._http.post(Configuration.urls.webApiEndpoint + url, itemNames).toPromise();
        var parsedResponse = JSON.parse(response.text());
        return parsedResponse;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/user-control-access.service.ts